import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { streamName: String };

  connect() {
    this.subscription = App.cable.subscriptions.create(
      { channel: "AccountingDocumentChannel", stream_name: this.streamNameValue },
      {
        connected: () => {
          this.element.dataset.ocrSubscriptionConnected = "true";
        },
        received: (data) => {
          document.dispatchEvent(new CustomEvent("accountingDocument:ocrProcessed", { detail: data }));
        },
      }
    );
  }

  disconnect() {
    this._removeOcrProcessingSubscription();
  }

  _removeOcrProcessingSubscription() {
    App.cable.subscriptions.remove(this.subscription);
  }
}
